import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

const AutheLayoutLeftPanel = (): ReactElement => (
    <Box className="auth-full-background">
        <Box className="left-panel">
            <Box
                className="bg-image"
                style={{
                    backgroundImage: `url("/images/brand/bg_login.png")`,
                }}
            >
                <Box className="p-10">
                    <Typography variant="h2" className="title">
                        Cross Check Verification <br />
                        and audit report
                    </Typography>
                    <Typography variant="h6" className="text-color subtitle">
                        Verified Cross Check File containing Verification
                        CheckList Report, Documents <br />
                        (Verified), and Security Cross Check Summary Report
                    </Typography>
                    <img
                        className="app-logo"
                        src="/images/brand/Fujifilm_Logo_Alternative_0.svg"
                        width={270}
                        height={45}
                    />
                </Box>
            </Box>
        </Box>
    </Box>
);

export default AutheLayoutLeftPanel;
